import {Permission} from "../../../models/permission";

export default {
  namespaced: true,
  state: {
    fetchedList: [],
  },
  getters: {
    getFetchedList: (state) => state.fetchedList,
  },
  mutations: {
    setFetchedList(state, val) {
      state.fetchedList = val;
    }
  },
  actions: {
    fetchList({ commit }) {
      Permission.$query().get(100).then((response) => {
        commit('setFetchedList', response.map(item => item.$attributes));
      })
    }
  }
}
